import axios from 'axios';
import { Logger } from '@utils/logger';
import { getDataFromPocket } from '@utils/pocket';

// NB: always use production instance here; staging can't detect your IP because it's internal
const API_ENDPOINT = 'https://websiteapi.acronis.com/geo/location/v1/ip/geolocation';

export default {
    namespaced: true,

    state: () => ({
        location: null,
        showLocaleSelector: false,
        requestedLocale: null,
        desiredLocale: null,
        finalLocale: null,
        isLanguageAware: false,
        language: null,
    }),

    actions: {
        async getGeoLocation(store) {
            try {
                if (store.state.location) {
                    return;
                }

                const fromPocket = getDataFromPocket('geo', false);

                if (fromPocket) {
                    // NB: don't address `.data` here; pocket uses `fetch()`
                    store.commit('setGeolocation', fromPocket);
                    return;
                }

                const fromApi = await axios.get(API_ENDPOINT);

                if (!fromApi.data) {
                    throw new Error('Error: getGeoLocation');
                }

                store.commit('setGeolocation', fromApi.data);
            } catch (error) {
                Logger.error({ error });
            }
        },

        updateRequestedLocale(store, locale) {
            store.commit('setRequestedLocale', locale);
        },

        updateDesiredLocale(store, locale) {
            store.commit('setDesiredLocale', locale);
        },

        updateFinalLocale(store, locale) {
            store.commit('setFinalLocale', locale);
        },

        updateIsLanguageAwareFlag(store, flag) {
            store.commit('setIsLanguageAware', flag);
        },

        updateLanguage(store, lang) {
            store.commit('setLanguage', lang);
        },
    },

    mutations: {
        setGeolocation(state, location) {
            state.location = location;
        },

        setRequestedLocale(state, locale) {
            state.requestedLocale = locale;
        },

        setDesiredLocale(state, locale) {
            state.desiredLocale = locale;
        },

        setFinalLocale(state, locale) {
            state.finalLocale = locale;
        },

        setIsLanguageAware(state, flag) {
            state.isLanguageAware = flag;
        },

        setLanguage(state, lang) {
            state.language = lang;
        },
    },
};
